import {HTTP_METHODS} from '@/utils/constants/httpMethods'
import {API_VERSION} from '@/utils/constants/commonConstants'

export const TIER_CONFIG = {
  TIERS: {
    endPoint: 'tiers/tier-setup',
    method: HTTP_METHODS.GET,
  },
  GET_TIER_DETAILS: (tierID) => ({
    endPoint: `tiers/${tierID}`,
    method: HTTP_METHODS.GET,
    version: API_VERSION.V1,
  }),
  CREATE_UPDATE_TIER: {
    endPoint: 'tiers',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1,
  },
  TIER_STORES: (tierID, queryParams, page, paginationSize) => ({
    endPoint: `tiers/${tierID}/stores?limit=${paginationSize}&page=${page}${queryParams}`,
    method: HTTP_METHODS.GET,
  }),
  CREATE_TIER_OPTIONS: {
    endPoint: 'tiers/create-tier-options',
    method: HTTP_METHODS.GET,
    version: API_VERSION.V1,
  },
  MOVE_STORES: tierID => ({
    endPoint: `tiers/${tierID}/move-stores`,
    method: HTTP_METHODS.POST,
  }),
  UPLOAD_TIER_STORES: {
    endPoint: 'tiers/upload-stores',
    method: HTTP_METHODS.POST,
  },
  UPLOAD_TIER_IMAGE: {
    endPoint: 'tiers/image',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1,
    contentType: 'multipart/form-data'
  },
  GET_FILTERED_STORES_BY_STOREID: (tierID, searchArr, page, limit) => ({
    endPoint: `tiers/${tierID}/filtering-stores-by-store-id?page=${page}&limit=${limit}&storeId=${searchArr}&`,
    method: HTTP_METHODS.GET,
    version: API_VERSION.V1,
    headers: { 'siteId': 21 },
  }),
  GET_FILTERED_STORES_BY_DATE: (tierID, searchArr, page, limit) => ({
    endPoint: `tiers/${tierID}/filtering-stores-by-date?filterDate=${searchArr}&page=${page}&limit=${limit}`,
    method: HTTP_METHODS.GET,
    version: API_VERSION.V1,
    headers: { 'siteId': 21 },
  }),
}
